import {API} from "../api/axios";
const END_POINT_HW = '/school';
const END_POINT = '/schools';
const END_POINT_FILTER='/schools-filter'
const END_POINT_MODULES = '/modules'
const END_POINT_CATEGORIES = '/school-categories'
class SchoolService {
  
  create(data) {
    return API.post(END_POINT_HW, data);
  }
  import(params){
    return API.post('import-school',params)
  }
  getAll(params) {
    return API.get(END_POINT,params)
  }
  getAllModules(params) {
    return API.get(END_POINT_MODULES,params)
  }
  getAllGategories(params) {
    return API.get(END_POINT_CATEGORIES,params)
  }
  getGouvernorat(params){
    return API.get(END_POINT_FILTER,params)
  }
  getById(id) {
    return API.get(`${END_POINT_HW}${END_POINT}/${id}`);
 }

  delete(id) {
    return API.delete(`${END_POINT_HW}/${id}`);
  }
  update(id, data) {
    return API.post(`${END_POINT_HW}/${id}`, data);
}

}

export default new SchoolService();